<template>
	<i :class="'fa fa-' + icon">
		<!-- TODO - implement icon system, e. g. FontAwesome -->
		{{ icon }} icon
	</i>
</template>

<script>
	export default {
		name: "Icon",
		props: [
			"icon"
		]
	}
</script>
